import { ITableColumn } from "src/app/common/components/table/interfaces/table-column";
import { NotificationSettingsKWPCellComponent } from "../components/notification-settings-kwp-cell/notification-settings-kwp-cell.component";

export const notificationSettingsKWP: Array<ITableColumn> = [
  {
    id: "municipality",
    key: "NOTIFICATION_SERVICE.TABLE_COLUMNS.ALL_MUNICIPALITIES",
    type: "text"
  },
  {
    id: "email",
    key: "NOTIFICATION_SERVICE.TABLE_COLUMNS.EMAIL",
    type: "custom",
    customTemplate: NotificationSettingsKWPCellComponent,
    propertyAccessor: (data, id) => data[id]
  },
  {
    id: "edit",
    key: "",
    type: "action",
    actionIcon: "ec_edit",
    columnStyles: "grey",
    style: {
      minWidth: "3rem",
      maxWidth: "3rem"
    },
    stickyEnd: true
  }
];
